import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../queryKeys';
import type { NoteResponse } from '../types';

/** GET /api/notes?sort=recent|priority -- für die Glocke (AppBar-Benachrichtigungen, F-15/F-19). */
export function useNotes(sort: 'recent' | 'priority' = 'recent') {
  return useQuery({
    queryKey: queryKeys.notes(sort),
    queryFn: () => api.get<readonly NoteResponse[]>('/api/notes', { sort }),
  });
}
